import { render } from "./Duration.vue?vue&type=template&id=2d75b040"
import script from "./Duration.vue?vue&type=script&lang=ts"
export * from "./Duration.vue?vue&type=script&lang=ts"
script.render = render

export default script